import { render, staticRenderFns } from "./EventViewDialog.vue?vue&type=template&id=ea997278&scoped=true"
import script from "./EventViewDialog.vue?vue&type=script&lang=js"
export * from "./EventViewDialog.vue?vue&type=script&lang=js"
import style0 from "./EventViewDialog.vue?vue&type=style&index=0&id=ea997278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea997278",
  null
  
)

export default component.exports